import styled from 'styled-components';

export const FieldSection = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  padding: 1.25rem;
  margin: 1.5rem 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.15);
  }
`;

export const SectionTitle = styled.h3`
  color: var(--clr-sec);
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &::before {
    content: '';
    width: 4px;
    height: 18px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 2px;
  }
`;

export const FieldLabel = styled.label`
  display: block;
  color: var(--clr-sec);
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  opacity: 0.9;
`;

export const FieldInput = styled.input`
  width: 100%;
  padding: 0.875rem;
  font-size: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  color: var(--clr-sec);
  box-sizing: border-box;
  outline: none;
  transition: all 0.3s ease;

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }

  &:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &.error {
    border-color: #ff6b6b;
    box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.compact {
    width: auto;
    flex: 1;
    min-width: 120px;
  }
`;

export const FieldSelect = styled.select`
  width: 100%;
  padding: 0.875rem;
  font-size: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  color: var(--clr-sec);
  box-sizing: border-box;
  outline: none;
  cursor: pointer;
  transition: all 0.3s ease;

  &:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.compact {
    width: auto;
    flex: 1;
    min-width: 180px;
  }

  option {
    background: var(--clr-bg);
    color: var(--clr-sec);
  }
`;

export const InlineFieldContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const PrivacyToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.75rem;
  padding: 0.75rem;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);

  &.inline {
    margin-top: 0;
    padding: 0;
    background: none;
    border: none;
    gap: 1rem;
    margin-left: 1rem;
  }
`;

export const PrivacyLabel = styled.span`
  color: var(--clr-sec);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  opacity: 0.9;
`;

export const PrivacyToggle = styled.button`
  background: ${(props) =>
    props.isPublic 
      ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
      : 'rgba(255, 255, 255, 0.1)'
  };
  border: none;
  border-radius: 20px;
  padding: 6px 14px;
  color: ${(props) => (props.isPublic ? 'white' : 'var(--clr-sec)')};
  cursor: pointer;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
  box-shadow: ${(props) =>
    props.isPublic ? '0 4px 12px rgba(102, 126, 234, 0.3)' : 'none'
  };

  &:hover {
    transform: translateY(-1px);
    box-shadow: ${(props) =>
      props.isPublic 
        ? '0 6px 16px rgba(102, 126, 234, 0.4)' 
        : '0 2px 8px rgba(255, 255, 255, 0.1)'
    };
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const CharacterCount = styled.p`
  color: var(--clr-sec);
  font-size: 0.75rem;
  text-align: right;
  margin: 0.25rem 0 0 0;
  opacity: 0.6;
`;

export const ErrorMessage = styled.p`
  color: #ff8a8a;
  font-size: 0.85rem;
  margin: 0.5rem 0;
  padding: 0.5rem;
  background: rgba(255, 107, 107, 0.1);
  border-radius: 6px;
  border-left: 3px solid #ff6b6b;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;